
import Vue from 'vue';
import { ListModel as DexListModel } from '@descomplica/dex-models';
import { Button, Icon } from '@descomplica/vue-components';
import StudyPlanningList from './StudyPlanningList.vue';

type WeeklyList = DexListModel & { isOverdue: boolean };

export default Vue.extend({
  name: 'SectionCards',
  components: {
    StudyPlanningList,
    Button,
    Icon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    shouldShowToggle: {
      type: Boolean,
      default: false,
    },
    weekNumber: {
      type: Number,
      default: 0,
    },
    subtitle: {
      type: String,
      default: '',
    },
    trackCard: {
      type: Function,
      default: () => {},
    },
    lists: {
      type: Array as Vue.PropType<WeeklyList[]>,
      required: true,
    },
    arePastWeeksListsFinished: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  watch: {
    lists() {
      this.resize(false);
    },
    isOpen(newValue: boolean) {
      this.resize(newValue);
    },
  },
  mounted() {
    if (this.isOpen) {
      (this.$refs.cardsContainer as HTMLElement).style.maxHeight = `${
        (this.$refs.cards as HTMLElement).scrollHeight
      }px`;
    }
  },
  created() {
    window.addEventListener('resize', this.changeMaxHeightOnResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.changeMaxHeightOnResize);
  },
  methods: {
    changeMaxHeightOnResize(): void {
      this.resize(this.isOpen);
    },
    resize(isOpen: boolean): void {
      if (isOpen) {
        (this.$refs.cardsContainer as HTMLElement).style.maxHeight = `${
          (this.$refs.cards as HTMLElement).scrollHeight
        }px`;

        return;
      }

      (this.$refs.cardsContainer as HTMLElement).style.maxHeight = '';
    },
    toggleSection() {
      this.$emit('toggleSection', this.weekNumber - 1);
    },
    isFirstIncompleteStudyPlanningList(index: number, list: WeeklyList): boolean {
      if (this.arePastWeeksListsFinished === undefined) {
        return index === 0 && list.progress !== 100;
      }

      return this.arePastWeeksListsFinished && index === 0 && list.progress !== 100;
    },
  },
});
